import React, { useEffect, useState } from 'react';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import { useRecoilState } from 'recoil';

// Atom import
import { selectedChatView } from '../../contexts/atoms';

// Style import
import { Container } from './style';

export function ChatViewSwitch() {
  // States
  const [beamerIsVisible, setBeamerIsVisible] = useState(false);
  const [selectedChatViewState, setSelectedChatViewState] = useRecoilState(
    selectedChatView
  );

  const toggleChecked = (
    _: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setSelectedChatViewState(checked ? 'CONVERSATIONS' : 'KANBAN');
  };

  useEffect(() => {
    const beamerScript = document.querySelector(
      'script[src="https://app.getbeamer.com/js/beamer-embed.js"]'
    );

    setBeamerIsVisible(!!beamerScript);

    return () => setSelectedChatViewState('KANBAN');
  }, []);

  return (
    <Container beamerIsVisible={beamerIsVisible}>
      <Grid item>
        <p>Kanban</p>
      </Grid>

      <Grid item>
        <FormControlLabel
          value="top"
          control={
            <Switch
              size="small"
              checked={selectedChatViewState === 'CONVERSATIONS'}
              onChange={toggleChecked}
              color="primary"
            />
          }
          label=""
          labelPlacement="top"
        />
      </Grid>

      <Grid item>
        <p>Conversas</p>
      </Grid>
    </Container>
  );
}
